import type { ReactNode } from 'react';
import { Link } from 'wouter';

interface HeaderProps {
  title: ReactNode;
}

export function Header({ title }: HeaderProps) {
  return (
    <header className="relative h-[72px] shrink-0 px-4 py-4 md:h-[96px]">
      <Link
        href="/"
        className="absolute left-4 top-4 cursor-pointer text-base font-light text-black transition-opacity duration-200 ease-in-out hover:opacity-70 md:text-xl"
      >
        <span>Salief Lewis</span>
      </Link>
      <div className="absolute right-4 top-4 max-w-[calc(100vw-10rem)] truncate text-right text-base font-[350] text-black md:max-w-[calc(100vw-16rem)] md:text-xl">
        {title}
      </div>
    </header>
  );
}
